import { css } from 'styled-system/css';

export const modalContainerStyle = {
	modal: css({
		'& .modal__container': {
			maxWidth: '354px',
		},
		'& .modal__body': {
			md: {
				height: '552px', // 600px - 48px
			},
			_mdBelow: {
				height: '70vh',
			}
		},
	}),
	modalWapper: css({
		p: '12px',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	}),
}